import type { FilterModule } from "../index";
import { IntentFilter } from "./IntentFilter";
import { defaultIntentSlice, type IntentSlice } from "./slice";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { getChips, getCount, type IntentLookups } from "./chips";

export const intentModule: FilterModule<IntentSlice, IntentLookups> = {
  key: "intent",
  defaultSlice: defaultIntentSlice,
  Component: IntentFilter,
  toCompanyFilters,
  fromCompanyFilters,
  getChips,
  getCount,
};

export type { IntentSlice, CachedTopic } from "./slice";
export { defaultIntentSlice } from "./slice";
export { IntentFilter } from "./IntentFilter";
export type {
  IntentOptions,
  BuyersJourneyOption,
  ContextTypeOption,
} from "./options";
export type { IntentLookups } from "./chips";
